import React from 'react'
import { useIntl } from 'react-intl'
import { useFragment } from 'react-relay-offline'
import { useDrawer } from '@/ui/components'

import { ProductDetailsSectionItem } from './ProductDetailsSectionItem'
import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'
import { ProductDetailsDrawer, productFragment } from './ProductDetailsDrawer'

type ProductDetailsProps = {
  productDescription: ProductDetailsDrawer_Product$key | null
}

export const ProductDetails = ({ productDescription }: ProductDetailsProps) => {
  const { formatMessage } = useIntl()

  const productData = useFragment(productFragment, productDescription)
  const hasProductDescription = productData?.description !== ''

  const productDetailsDrawer = useDrawer({
    route: `#/product-details-drawer`,
  })

  if (productData?.description === undefined || !hasProductDescription) {
    return null
  }

  return (
    <>
      <ProductDetailsSectionItem
        onClick={() => productDetailsDrawer.open()}
        title={formatMessage({ id: 'productDetailsDrawerTitle' })}
      />
      <ProductDetailsDrawer
        productDescription={productDescription}
        isOpen={productDetailsDrawer.isOpen}
        onClose={() => productDetailsDrawer.onClose()}
      />
    </>
  )
}
